/* sk8 Monster Drops, tema PS2, gaveta.js.
   Dono: frente 1 (produto). A gaveta da sacola (carrinho lateral,
   snippets/gaveta.liquid): abre pela direita ao adicionar um item
   (produto.js chama SK8.abrirGaveta com a sacola ja atualizada) e pelo icone
   da sacola no HUD (a[data-sacola]; sem JS o icone segue para /cart).
   Desenha os itens a partir de /cart.js, muda quantidade e remove por
   /cart/change.js e atualiza o medidor do HUD (SK8.atualizarSacola). Fundo
   escurecido, Esc e toque fora fecham; foco preso dentro enquanto aberta.
   "Finalizar compra" e um form do proprio snippet, igual ao da pagina /cart.
   Carrega em toda pagina pelo layout, depois de base.js (usa SK8.$, SK8.$$,
   SK8.som, SK8.atualizarSacola, SK8.rotas). Expoe SK8.abrirGaveta(sacola,
   origem), SK8.fecharGaveta() e SK8.recarregarGaveta(). */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$ || function (s, r) { return (r || document).querySelector(s); };
  var $$ = SK8.$$ || function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var Som = SK8.som || { tocar: function () {} };
  var gaveta = $("#gaveta"), fundo = $("[data-gaveta-fundo]");
  if (!gaveta || !fundo || !window.fetch) return;

  var rotas = SK8.rotas || { sacola: "/cart" };
  var lista = $("[data-gaveta-lista]", gaveta), vazia = $("[data-gaveta-vazia]", gaveta);
  var carregando = $("[data-gaveta-carregando]", gaveta), aviso = $("[data-gaveta-aviso]", gaveta);
  var subtotal = $("[data-gaveta-subtotal]", gaveta), contagem = $("[data-gaveta-contagem]", gaveta);
  var sacola = null, pedido = null, aberta = false, ocupado = false, origem = null, tempoFechar = 0;

  var MENOS = '<svg viewBox="0 0 12 12" aria-hidden="true" shape-rendering="crispEdges"><rect x="1" y="5" width="10" height="2"/></svg>';
  var MAIS = '<svg viewBox="0 0 12 12" aria-hidden="true" shape-rendering="crispEdges"><rect x="5" y="1" width="2" height="10"/><rect x="1" y="5" width="10" height="2"/></svg>';

  function dinheiro(c) {
    var n = Math.round(Number(c) || 0), reais = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var cent = String(n % 100);
    return "R$ " + reais + "," + (cent.length < 2 ? "0" + cent : cent);
  }
  function esc(t) {
    return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  // o nome curto e o que esta entre aspas no titulo, igual a pagina /cart
  function nomeCurto(t) { var p = String(t || "").split('"'); return p.length > 2 ? p[1] : t; }
  function miniatura(url) { return url ? url + (url.indexOf("?") < 0 ? "?" : "&") + "width=160" : ""; }
  function detalhe(item) {
    if (item.product_has_only_default_variant) return "";
    var o = item.options_with_values || [];
    if (o.length) return o.map(function (x) { return x.name + ": " + x.value; }).join(" / ");
    return item.variant_title || "";
  }

  function mostrarAviso(texto) { aviso.textContent = texto || ""; aviso.hidden = !texto; }

  function desenhar(c) {
    if (c) sacola = c;
    if (!sacola) return;
    var itens = sacola.items || [], n = sacola.item_count || 0;
    carregando.hidden = true;
    lista.innerHTML = itens.map(function (item) {
      var nome = nomeCurto(item.product_title), det = detalhe(item);
      return '<li class="gaveta-item" data-chave="' + esc(item.key) + '" data-qtd-atual="' + item.quantity + '">' +
        '<a class="gaveta-foto px" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (item.image ? '<img src="' + esc(miniatura(item.image)) + '" alt="" width="72" height="72">' : "") + "</a>" +
        '<div class="gaveta-info">' +
          '<a class="gaveta-nome" href="' + esc(item.url) + '" data-nav>' + esc(nome) + "</a>" +
          (det ? '<span class="gaveta-detalhe">' + esc(det) + "</span>" : "") +
          '<div class="gaveta-qtd px" role="group" aria-label="Quantidade de ' + esc(nome) + '">' +
            '<button type="button" data-qtd="-1" aria-label="Diminuir a quantidade" data-nav>' + MENOS + "</button>" +
            "<span>" + item.quantity + "</span>" +
            '<button type="button" data-qtd="1" aria-label="Aumentar a quantidade" data-nav>' + MAIS + "</button>" +
          "</div>" +
        "</div>" +
        '<div class="gaveta-preco">' + dinheiro(item.final_line_price) +
          '<button type="button" class="gaveta-remover" data-remover aria-label="Remover ' + esc(nome) + (det ? ", " + esc(det) : "") + ', da sacola" data-nav>Remover</button>' +
        "</div>" +
      "</li>";
    }).join("");
    var tem = itens.length > 0;
    gaveta.classList.toggle("vazia", !tem);
    vazia.hidden = tem;
    lista.hidden = !tem;
    $$("[data-gaveta-cheia]", gaveta).forEach(function (el) { el.hidden = !tem; });
    subtotal.textContent = dinheiro(sacola.total_price);
    contagem.textContent = n + (n === 1 ? " item" : " itens");
  }

  function buscar() {
    if (!pedido) {
      pedido = fetch(rotas.sacola + ".js", { headers: { Accept: "application/json" }, cache: "no-store" })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (c) { pedido = null; return c; }, function (e) { pedido = null; throw e; });
    }
    return pedido;
  }
  function recarregar() {
    return buscar().then(function (c) {
      desenhar(c);
      if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      return c;
    }).catch(function () {
      carregando.hidden = true;
      mostrarAviso("Não foi possível carregar a sacola. Verifique a sua conexão e tente novamente.");
    });
  }

  // ------------------------------------------------------------------ abrir e fechar
  function focaveis() {
    return $$('a[href]:not([tabindex="-1"]), button:not([disabled])', gaveta).filter(function (el) {
      return el.getClientRects().length > 0 && !el.closest("[hidden]");
    });
  }
  function abrir(c, deOnde) {
    origem = deOnde || document.activeElement;
    mostrarAviso("");
    if (c) desenhar(c);
    else if (!sacola) { carregando.hidden = false; lista.hidden = true; vazia.hidden = true; }
    else desenhar();
    if (!c) recarregar();
    if (aberta) return;
    aberta = true;
    clearTimeout(tempoFechar);
    gaveta.hidden = false;
    fundo.hidden = false;
    void gaveta.offsetWidth; // o navegador precisa ver a gaveta fora da tela antes de deslizar
    gaveta.classList.add("aberta");
    fundo.classList.add("aberto");
    document.documentElement.classList.add("gaveta-aberta");
    gaveta.focus({ preventScroll: true });
  }
  function fechar() {
    if (!aberta) return;
    aberta = false;
    gaveta.classList.remove("aberta");
    fundo.classList.remove("aberto");
    document.documentElement.classList.remove("gaveta-aberta");
    tempoFechar = setTimeout(function () { gaveta.hidden = true; fundo.hidden = true; }, 220);
    if (origem && origem.focus && document.documentElement.contains(origem)) origem.focus({ preventScroll: true });
    origem = null;
  }
  SK8.abrirGaveta = abrir;
  SK8.fecharGaveta = fechar;
  SK8.recarregarGaveta = recarregar;

  $$("[data-gaveta-fechar]", gaveta).forEach(function (b) {
    b.addEventListener("click", function () { Som.tocar("voltar"); fechar(); });
  });
  fundo.addEventListener("click", function () { Som.tocar("voltar"); fechar(); });

  // icone da sacola no HUD: abre a gaveta; clique com Ctrl, Shift ou botao do meio segue para /cart
  $$("a[data-sacola]").forEach(function (a) {
    a.setAttribute("aria-haspopup", "dialog");
    a.setAttribute("aria-controls", "gaveta");
    ["pointerenter", "touchstart", "focus"].forEach(function (ev) {
      a.addEventListener(ev, function () { if (!sacola) buscar().then(desenhar).catch(function () {}); }, { passive: true, once: true });
    });
    a.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      Som.tocar("confirmar");
      abrir(null, a);
    });
  });

  // teclado com a gaveta aberta: Esc fecha, Tab e setas andam so dentro dela
  var SETAS = { ArrowUp: -1, ArrowLeft: -1, ArrowDown: 1, ArrowRight: 1 };
  document.addEventListener("keydown", function (e) {
    if (!aberta) return;
    if (e.key === "Escape") {
      e.preventDefault(); e.stopPropagation();
      Som.tocar("voltar");
      fechar();
      return;
    }
    var passo = e.key === "Tab" ? (e.shiftKey ? -1 : 1) : SETAS[e.key];
    if (!passo || e.altKey || e.metaKey || e.ctrlKey) return;
    var itens = focaveis();
    if (!itens.length) return;
    var i = itens.indexOf(document.activeElement);
    var proximo = i < 0 ? (passo > 0 ? itens[0] : itens[itens.length - 1]) : itens[(i + passo + itens.length) % itens.length];
    e.preventDefault();
    e.stopPropagation();
    proximo.focus();
    if (e.key !== "Tab") { document.documentElement.classList.add("usando-teclado"); Som.tocar("mover"); }
  }, true);
  // foco que escapar (clique, leitor de tela) volta para dentro
  document.addEventListener("focusin", function (e) {
    if (aberta && !gaveta.contains(e.target)) { var f = focaveis()[0]; (f || gaveta).focus({ preventScroll: true }); }
  });

  // ------------------------------------------------------------------ quantidade e remover
  lista.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qtd], [data-remover]");
    if (!b || ocupado) return;
    var linha = b.closest("[data-chave]");
    if (!linha) return;
    var chave = linha.getAttribute("data-chave"), atual = Number(linha.getAttribute("data-qtd-atual")) || 0;
    var remover = b.hasAttribute("data-remover");
    var nova = remover ? 0 : Math.max(0, atual + Number(b.getAttribute("data-qtd")));
    var foco = remover || nova === 0 ? null : "[data-qtd='" + b.getAttribute("data-qtd") + "']";
    var posicao = $$("[data-chave]", lista).indexOf(linha);
    Som.tocar(nova < atual ? "voltar" : "mover");
    ocupado = true;
    gaveta.classList.add("ocupada");
    lista.setAttribute("aria-busy", "true");
    mostrarAviso("");
    fetch(rotas.sacola + "/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: chave, quantity: nova })
    }).then(function (r) {
      if (!r.ok) { var falha = new Error("sacola"); falha.status = r.status; throw falha; }
      return r.json();
    }).then(function (c) {
      desenhar(c);
      if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      if (c.items && c.items.length && nova > atual && !c.items.some(function (it) { return it.key === chave && it.quantity === nova; })) {
        mostrarAviso("Não há mais unidades deste tamanho em estoque.");
      }
    }).catch(function (falha) {
      Som.tocar("erro");
      mostrarAviso(falha && falha.status === 422
        ? "Não há mais unidades deste tamanho em estoque."
        : "Não foi possível atualizar a sacola. Verifique a sua conexão e tente novamente.");
      return recarregar();
    }).then(function () {
      ocupado = false;
      gaveta.classList.remove("ocupada");
      lista.removeAttribute("aria-busy");
      // devolve o foco para o mesmo controle (ou para o item de baixo, se o item saiu)
      var alvo = null;
      var mesma = $$("[data-chave]", lista).filter(function (l) { return l.getAttribute("data-chave") === chave; })[0];
      if (mesma && foco) alvo = $(foco, mesma);
      if (!alvo) { var linhas = $$("[data-chave]", lista); var l = linhas[Math.min(posicao, linhas.length - 1)]; alvo = l ? $("[data-remover]", l) : null; }
      if (aberta) (alvo || focaveis()[0] || gaveta).focus({ preventScroll: true });
    });
  });

  // voltar do pagamento pelo navegador devolve a pagina da memoria: a sacola pode ter mudado
  window.addEventListener("pageshow", function (e) { if (e.persisted && (aberta || sacola)) recarregar(); });

  window.SK8 = SK8;
})();
